import angular from 'angular';

// Libraries
import uiModal from 'angular-ui-bootstrap/src/modal';

// Controller
import ConfirmController from './confirmModal.controller';
import template from './confirmModal.html';

const moduleName = 'recaps.editor.modals.confirm';
let module = angular.module(moduleName, [
  uiModal,
]);

module.controller('ConfirmController', ConfirmController);
module.factory('showConfirmModal', ['$uibModal', ($uibModal) => {
  return props => {
    let modal = $uibModal.open({
      template: template,
      controller: ConfirmController,
      controllerAs: 'vm',
      size: props.size || 'sm',
      resolve: {
        message: () => props.message || props,
        title: () => props.title || '',
        showAdditionalButton: () => props.showAdditionalButton || false,
        additionalButtonText: () => props.additionalButtonText || '',
        additionalButtonAction: () => props.additionalButtonAction || null

      }
    });
    return modal.result;
  };
}]);

export default module;
